import React, { useState, useEffect } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import logo from "../../common/media/cc_logo_white.svg";
import logo_color from "../../common/media/cc_logo_color.svg";
import { formatNumber } from "../../common/util/numberFormatter";
import logo_merchant from "../../common/media/cc_logo_color.svg"; // use here or from cloudinary
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProjectsList from "../../common/components/Projects/ProjectsList";
import { Carousel } from 'react-responsive-carousel';
import { projects as getProjects } from '../../common/api/projects'
import Popover from "../../common/components/popover/popover.js";
import { getFlightSuffix } from "../../common/util/unitConverter";
import FlightCalculator from "../../common/components/offset/FlightCalculatorV2";
import { getMerchantCodeWithPrefix } from '../../../tools/MyCCMerchantLinkGenerator';

const LandingPage = ({ merchantCode, fetchedImpact }) => {

    const [selectedPlan, setSelectedPlan] = useState({});
    const [projects, setProjects] = useState();

    useEffect(() => {
        getProjects("AU")
            .then(response => response.json())
            .then(data => setProjects(data))
            .catch(setProjects);

    }, []);
    const planChosen = () => {
        history.push("subscribe/payment");
    };
    return (
        <div>
            <div >
                <div className="px-3">
                    <img className="mw-100 center" src="https://res.cloudinary.com/carbonclick/image/upload/v1618807530/Enterprise/Ton%20Of%20Fun/tonoffun-hero_bbmfch.png" />
                </div>
            </div>

            <div id="content" className="py-6">
                <div className="container text-center">
                    <div className="mb-3 center mw-600px">
                        <img className="center mb-3" style={{height: '210px'}} src="https://res.cloudinary.com/carbonclick/image/upload/v1619048781/Enterprise/Ton%20Of%20Fun/ATOF-icon_yhnh7t.png" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="mb-3 shadow">
                    <iframe allow="payment *" frameBorder="0" className="w-100 flight-calculator-height bg-white" src={`${process.env.MY_CC_URL}/purchase-offset?merchantCode=${merchantCode}`}></iframe>
                </div>
            </div>

            <div className="bg-secondary position-relative py-5 img-contain" id="FlightCalculator" style={{ backgroundRepeat: "no-repeat", backgroundPosition: "left" }}>
                <div className="container mobile-p-0 position-relative z-2">
                    <div className="mb-3 text-center">
                        <h3 className="font-bold">Inspired to make a difference?</h3>
                        <h5>Make an ongoing contribution and make a real, traceable difference on your everyday footprint</h5>
                    </div>
                    <div className="row m-0">
                        <div className="col-3 d-grid p-0 mb-3">
                            <div className="flex-column bg-white shadow mx-3">
                                <div className="img-cover h-160px bg-grey w-100" style={{backgroundImage: 'url("https://res.cloudinary.com/carbonclick/image/upload/v1602122540/CFT-Impact-CO2_bg5wqm.png")'}}>

                                </div>
                                <div className="p-3 flex-grow text-center">
                                    <h4>Light</h4>
                                    <p>This will cover a portion of your monthly carbon footprint.</p>
                                </div>
                                <div className="mb-3 w-100 px-3 text-center">
                                    <a href={`https://my.carbon.click/${getMerchantCodeWithPrefix(merchantCode)}/subscribe?recommendedPricingLevel=10`} target="_blank" type="button" className="w-100 btn btn-primary mb-3"><span className="currencySymbol">$</span><span className="price">15.00</span> / month</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-3 d-grid p-0 mb-3" >
                            <div className="flex-column bg-white shadow mx-3">
                                <div className="img-cover h-160px bg-grey w-100" style={{backgroundImage: 'url("https://res.cloudinary.com/carbonclick/image/upload/v1605150528/Project%20Baskets/Doha/Australia_i0vxjz.png")'}}>

                                </div>
                                <div className="p-3 flex-grow text-center">
                                    <h4>Everyday</h4>
                                    <p>For most people, this will cover the large part of their carbon footprint.</p>
                                </div>
                                <div className="mb-3 w-100 px-3 text-center">
                                    <a href={`https://my.carbon.click/${getMerchantCodeWithPrefix(merchantCode)}/subscribe?recommendedPricingLevel=20`} target="_blank" type="button" className="w-100 btn btn-primary mb-3"><span className="currencySymbol">$</span><span className="price">24.00</span> / month</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-3 d-grid p-0 mb-3">
                            <div className="flex-column bg-white shadow mx-3">
                                <div className="img-cover h-160px bg-grey w-100" style={{backgroundImage: 'url("https://res.cloudinary.com/carbonclick/image/upload/v1602122540/CFT-Impact-Trees_pve5l8.png")'}}>

                                </div>
                                <div className="p-3 flex-grow text-center">
                                    <h4>Family</h4>
                                    <p>Covers a good portion of a small family’s footprint.</p>
                                </div>
                                <div className="mb-3 w-100 px-3 text-center">
                                    <a href={`https://my.carbon.click/${getMerchantCodeWithPrefix(merchantCode)}/subscribe?recommendedPricingLevel=30`} target="_blank" type="button" className="w-100 btn btn-primary mb-3"><span className="currencySymbol">$</span><span className="price">49.00</span> / month</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-3 d-grid p-0 mb-3">
                            <div className="flex-column bg-white shadow mx-3">
                                <div className="img-cover h-160px bg-grey w-100" style={{backgroundImage: 'url("https://res.cloudinary.com/carbonclick/image/upload/v1603051574/Global_ln6eok.png")'}}>

                                </div>
                                <div className="p-3 flex-grow text-center">
                                    <h4>Hero</h4>
                                    <p>For climate rockstars! Cover your own climate footprint, and pay it forward to friends and family.</p>
                                </div>
                                <div className="mb-3 w-100 px-3 text-center">
                                    <a href={`https://my.carbon.click/${getMerchantCodeWithPrefix(merchantCode)}/subscribe?recommendedPricingLevel=40`} target="_blank" type="button" className="w-100 btn btn-primary mb-3"><span className="currencySymbol">$</span><span className="price">99.00</span> / month</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="position-absolute w-100 bottom-abs">
                    <img className="w-100" src="https://res.cloudinary.com/carbonclick/image/upload/v1619140443/Enterprise/Ton%20Of%20Fun/tof-bg_e7lxuo.png" />
                </div>
            </div>

            <div className="container py-5">
                <div className="bg-primary p-4 text-center">
                    <div className="center mw-720px">
                        <div className="mb-3">
                            <h3 className="font-bold">What is your carbon footprint?</h3>
                            <h5 className="mb-3">According to WHO, a carbon footprint is a measure of the impact your activities have on the amount of carbon dioxide (CO2) produced through the burning of fossil fuels and is expressed as a weight of CO2 emissions produced in tonnes.</h5>
                            <a href="https://my.carbon.click/calculator" target="_blank" className="btn btn-secondary">CALCULATE YOUR CARBON FOOTPRINT</a>
                        </div>
                        <div className="d-flex" style={{ justifyContent: 'center' }}>
                            <h6 className="font-bold mr-2 mt-1">Powered By</h6>
                            <div>
                                <img style={{ height: 30 }} src={logo_color} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            {Array.isArray(projects) &&
                <div className="py-6">
                    <div className="container text-center">
                        <div className="mb-5 center mw-600px">
                            <h3 className="font-bold">Support Projects That Fight<br />Climate Change</h3>
                            <p>A Ton of Fun’s small business offsets are powered by CarbonClick which supports only the highest quality carbon offsetting projects around the world, to bring you peace of mind and results.</p>
                        </div>
                        <div className="text-left mobile-text-center">
                            <ProjectsList title={null} projects={projects} />
                        </div>
                    </div>
                </div>
            }

            <div className="py-6 mobile-p-0">
                <div className="container text-center">
                    <h3 className="font-bold mb-4">Ton of Fun FAQs</h3>
                    <div className="mb-3 center text-left mw-800px">
                        <Accordian title={"What is a carbon offset?"} >A carbon credit is what is bought and sold when dealing with voluntary carbon offsets. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) or the Emissions Trading Register (New Zealand).</Accordian>
                        <Accordian title={"What does carbon offsetting do?"} >Carbon offsetting is a tool that allows individuals or companies to reduce their environmental impact. Purchasing carbon offsets supports environmental projects that remove greenhouse gases from the air, these projects could be things like reforestation projects or investment into renewable energy. Purchasing one carbon offset credit removes the equivalent of one tonne of CO2 from the atmosphere.</Accordian>
                        <Accordian title={"Who are CarbonClick?"} >A Ton of Fun has chosen to partner with CarbonClick, a New Zealand company that exists to reverse climate change, CarbonClick empowers businesses and their customers to tackle climate change, by making carbon offsets simple, trustworthy and cost effective. Building a happier and more sustainable future for everyone.</Accordian>
                        <Accordian title={"Where does the money go?"} >The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.</Accordian>
                        <Accordian title={"How do I know the offset is trustworthy?"} >CarbonClick is committed to making carbon offsetting safe and trustworthy, we do this by tracing every transaction to the projects it supported so you can see the retirement certificates for every kg of CO2 offset. The trace link is sent in every purchase confirmation email, and can also be found on our website.</Accordian>
                    </div>
                    <div className="mobile-show py-5"></div>
                </div>
            </div>

            <img className="w-100 center" src="https://res.cloudinary.com/carbonclick/image/upload/v1618807528/Enterprise/Ton%20Of%20Fun/TonofFunFooter_dh6tzz.png" />

            <div className="w-100 img-cover footer-img py-6 bg-tertiary" >
                <div className="container color-white py-5">
                    <p><b>A Ton of Fun Powered by</b></p>
                    <div className="d-flex">
                        <div>
                        <img style={{ height: 30 }} className="footer-logo" src={logo} alt="carbonclick" />
                        </div>
                    </div>
                    <hr className="mb-4" />

                    <div className="row">
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={"https://cc-prod-mail-assets.s3-ap-southeast-2.amazonaws.com/Privacy+Policy.pdf"} target="_blank" rel="noopener noreferrer">CarbonClick's Privacy policy</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={"https://cc-prod-mail-assets.s3-ap-southeast-2.amazonaws.com/Terms+of+Service.pdf"} target="_blank" rel="noopener noreferrer">CarbonClick's Terms &amp; Conditions</a></div>
                               
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default LandingPage;